import { useRef } from 'react';
import { COMPARATOR_TYPES, Filter, searchCreatorApi } from '~/searchApi';

const DELAY = 2000;

export function useSearchCreatorPolling() {
  const nowDate = new Date().toISOString();
  const creatorLastUpdatedDateRef = useRef(nowDate);

  const delay = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  async function checkUpdate(creatorId: string): Promise<boolean> {
    // criteria to filter the creator
    // 1 - creator id
    // 2 - creator after update 'updated_at' > last stored 'updated_at'
    const filters: Filter[] = [
      {
        name: 'id',
        comparator: COMPARATOR_TYPES.EQ,
        value: creatorId,
      },
      {
        name: 'updated_at',
        comparator: COMPARATOR_TYPES.GT,
        value: creatorLastUpdatedDateRef.current,
      },
    ];

    const response = await searchCreatorApi.getCreators({ filters });
    // if not meet the filter, then wait for 2 seconds and check again
    if (response.results.length === 0) {
      await delay(DELAY);

      return checkUpdate(creatorId);
    }

    // if the creator is updated and returned, then return true
    return true;
  }

  return {
    checkUpdate,
  };
}
